export const DRAW_NAME_HINTS = {
  name: "Internal name. Only shown to agents in Nova.",
  displayName:
    'Customer-facing name. Shown to customers in MyAccount, e.g. "November Prize Draw". Don\'t start it with "The", as MyAccount adds it ("Enter the November Prize Draw").',
} as const
